import { render, staticRenderFns } from "./VotacionCesionCreditos.vue?vue&type=template&id=614f12b2&scoped=true"
import script from "./VotacionCesionCreditos.vue?vue&type=script&lang=js"
export * from "./VotacionCesionCreditos.vue?vue&type=script&lang=js"
import style0 from "./VotacionCesionCreditos.vue?vue&type=style&index=0&id=614f12b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f12b2",
  null
  
)

export default component.exports